import React from 'react';
import { motion } from 'framer-motion';
import { Info } from 'lucide-react';
import { getStyles } from './wizardConstants';
import { useLanguage } from '../../context/LanguageContext';

export const StepGeneralInfo = ({ formData, setFormData, isDark }) => {
  const s = getStyles(isDark);
  const { t } = useLanguage();
  return (
    <motion.div key="step1" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} className="space-y-6">
      <div className={`mb-4 p-3 rounded-xl flex items-start gap-2 ${isDark ? 'bg-slate-700/50' : 'bg-gray-50'}`}>
        <Info className={`w-4 h-4 mt-0.5 flex-shrink-0 ${isDark ? 'text-blue-400' : 'text-blue-500'}`} />
        <p className={`text-sm ${isDark ? 'text-slate-400' : 'text-gray-500'}`}>
          {t('productWizard.general.sectionHelp')}
        </p>
      </div>
      <div>
        <label className={s.labelMd}>{t('productWizard.general.name')}</label>
        <input type="text" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          placeholder={t('productWizard.general.namePlaceholder')} className={s.inputLg} data-testid="product-name-input" />
      </div>
      <div>
        <label className={s.labelMd}>{t('productWizard.general.description')}</label>
        <textarea value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          rows={3} placeholder={t('productWizard.general.descriptionPlaceholder')} className={s.inputLg} data-testid="product-description-input" />
        <p className={`text-xs italic mt-1 ${isDark ? 'text-slate-500' : 'text-gray-400'}`}>
          {t('privacy.commentsDisclaimer')}
        </p>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className={s.labelMd}>{t('productWizard.general.type')}</label>
          <select value={formData.product_type} onChange={(e) => setFormData({ ...formData, product_type: e.target.value })}
            className={s.inputLg} data-testid="product-type-select">
            <option value="finished">{t('productWizard.general.typeFinished')}</option>
            <option value="semi_finished">{t('productWizard.general.typeSemiFinished')}</option>
          </select>
        </div>
        <div>
          <label className={s.labelMd}>{t('productWizard.general.unit')}</label>
          <select value={formData.unit} onChange={(e) => setFormData({ ...formData, unit: e.target.value })}
            className={s.inputLg} data-testid="product-unit-select">
            <option value="unit">{t('productWizard.general.unitPiece')}</option>
            <option value="kg">{t('productWizard.general.unitKilogram')}</option>
            <option value="m2">{t('productWizard.general.unitSquareMeter')}</option>
            <option value="m3">{t('productWizard.general.unitCubicMeter')}</option>
            <option value="L">{t('productWizard.general.unitLiter')}</option>
          </select>
        </div>
      </div>
      <div>
        <label className={s.labelMd}>{t('productWizard.general.lifespan')}</label>
        <input type="number" min="0.5" max="30" step="0.5" value={formData.lifespan_years === 0 ? '' : formData.lifespan_years}
          onChange={(e) => setFormData({ ...formData, lifespan_years: parseFloat(e.target.value) || 0 })}
          className={s.inputLg} placeholder="0" data-testid="product-lifespan-input" />
      </div>
      {formData.product_type === 'semi_finished' && (
        <div className={`p-4 rounded-xl ${isDark ? 'bg-blue-500/20' : 'bg-blue-50'} flex items-start gap-3`}>
          <Info className="w-5 h-5 text-blue-500 mt-0.5" />
          <p className={`text-sm ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>
            {t('productWizard.general.semiFinishedHelp')}
          </p>
        </div>
      )}
    </motion.div>
  );
};
